const BUSCA = 'busca'
const VALIDACAO = 'validacao'
const HIERARQUICA = 'hierarquica'
const BUSCA_VALIDACAO = 'busca-validacao'
const KYC = 'kyc'

export {
  BUSCA,
  VALIDACAO,
  HIERARQUICA,
  BUSCA_VALIDACAO,
  KYC
}
